// BIのaction
import * as AppUser from '../constants/AppUser';
import * as BarthelIndexConst from '../constants/BarthelIndexAPI';
import { AppUserAPI } from '../api/AppUser';
import { BarthelIndexAPI } from '../api/BarthelIndexAPI';

/**
 * BIを取得.
 *
 * @param {string} uniqueId
 * @param {string} startDate
 * @param {string} endDate
 * @returns
 */
const runGetBIRecordsAPI = (uniqueId: string, startDate: string, endDate: string) => {
  // BIのためのAPI
  const barthelIndexAPI = BarthelIndexAPI.instance;
  if (barthelIndexAPI === null) {
    return {
      type: BarthelIndexConst.ERROR,
      result: {
        bi: null
      },
    };
  }

  return barthelIndexAPI.getBIRecords(
    uniqueId, startDate, endDate,
    () => {
      return {
        type: BarthelIndexConst.LOADING,
        result: null,
      };
    },
    (state: any, result: any) => {
      switch (state) {
        case BarthelIndexConst.LOADING:
          return {
            type: BarthelIndexConst.LOADING,
            result: null,
          };
        case BarthelIndexConst.ERROR:
          return {
            type: BarthelIndexConst.ERROR,
            result: {
              bi: null 
            },
          };
        case BarthelIndexConst.SUCCESS:
          return {
            type: BarthelIndexConst.SUCCESS,
            result: {
              bi: result
            },
          };
        default:
          return {
            type: BarthelIndexConst.ERROR,
            result: {
              bi: null
            },
          };
      }
    }
  );
};

/**
 * BIに必要な情報を取得する.
 * ユニークID取得->BIのAPIコール.
 *
 * @param {string} uniqueId
 * @param {string} startDate BIにつかう開始日.
 * @param {string} endDateg BIにつかう最終日.
 * @returns
 */
export const getBIRecords = (userId: string, startDate: string, endDate: string) => {
  // ユニークキーを取るためのAPI
  const appUserAPI = AppUserAPI.instance;
  if (appUserAPI === null) {
    return {
      type: BarthelIndexConst.ERROR,
      result: {
        bi: null 
      },
    };
  }

  // アプリユーザーAPI(ユニークIDのを取るためだけに使う).
  return appUserAPI.getAppUser(
    userId,
    () => {
      return {
        type: BarthelIndexConst.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetUser: any, resultOfGetUser: any) => {
      switch (statusOfGetUser) {
        case AppUser.LOADING:
          return {
            type: BarthelIndexConst.LOADING,
            result: null,
          };
        case AppUser.ERROR:
          return {
            type: BarthelIndexConst.ERROR,
            result: resultOfGetUser,
          };
        case AppUser.SUCCESS:
          const uniqueId = (resultOfGetUser.data as AppUser.ResponseData).unique_id;
          return runGetBIRecordsAPI(uniqueId, startDate, endDate);
        default:
          return {
            type: BarthelIndexConst.ERROR,
            result: {
              bi: null 
            },
          };
      }
    }
  );
};

/**
 * 初期化する.
 *
 * @returns
 */
export const initialize = () => {
  return {
    type: BarthelIndexConst.INITIALIZE,
  };
};



// WEBPACK FOOTER //
// ./src/actions/BarthelIndex.tsx